import { useQuery } from "@tanstack/react-query";
import { useSetRecoilState } from "recoil";
import { GET_USER_INFO } from "../../common/query-keys";
import { User, userState } from "../../states/user";
import { request } from "../api";
import { readAccessToken } from "../authFunctions";
import React from "react";

interface UserProviderProps {
  children: React.ReactElement;
}

const UserProvider = ({ children }: UserProviderProps) => {
  const setUserState = useSetRecoilState(userState);
  const { data: user, isPending } = useQuery({
    queryKey: [GET_USER_INFO],
    queryFn: async () => {
      const accessToken = readAccessToken();
      if (!accessToken) {
        setUserState(null);
        return null;
      }

      try {
        const user = await request<User>({
          method: "GET",
          url: "/user/info",
        });
        setUserState(user);
        return user;
      } catch (error) {
        console.error("Failed to fetch user info:", error);
        setUserState(null);
        return null;
      }
    },
  });

  if (isPending) {
    return null;
  }

  return children;
};

export default UserProvider;
